/* global URLSearchParams */
const QUICK_SEARCH_PATH_SEGMENT = /\/quick_searches\/\d{26}/g;

/**
 * Build the href for switching quick-search template: replace the id in the path and,
 * when the current URL has _variant=flagship or prefiltered=true, preserve only those query params.
 *
 * @param {string} pathname - e.g. window.location.pathname
 * @param {string} newQuickSearchId
 * @param {string} [search] - e.g. window.location.search (may be empty or start with ?)
 * @returns {string} path + optional ?query
 */
export function quickSearchTemplateHref(pathname, newQuickSearchId, search = '') {
  let path = pathname.replace(
    QUICK_SEARCH_PATH_SEGMENT,
    `/quick_searches/${newQuickSearchId}`
  );
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  const out = new URLSearchParams();
  if (params.get('_variant') === 'flagship') {
    out.set('_variant', 'flagship');
  }

  // Default / Pre-filtered search for agents
  if (Flexmls.currentUser.role === 'private' && params.get('prefiltered') === 'true') {
    out.set('prefiltered', 'true');
  }
  const qs = out.toString();
  return qs ? `${path}?${qs}` : path;
}
